import type { EnergyAnalysisTrendSeries } from "features/energy-analysis-dashboard/model/types";

export const buildCorrectedBarSeries = (stacks: EnergyAnalysisTrendSeries[], asLine?: boolean) =>
  stacks.map((item) =>
    asLine
      ? {
          color: item.color,
          connectNulls: true,
          data: item.data,
          lineStyle: { color: item.color, width: 2 },
          name: item.name,
          symbol: "none",
          type: "line",
          z: 2,
        }
      : {
          barCategoryGap: "28%",
          barMaxWidth: 28,
          data: item.data,
          itemStyle: { color: item.color },
          name: item.name,
          stack: "corrected",
          type: "bar",
          z: 1,
        }
  );
